<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading">
    <div *ngIf="!paymentRequest.specificPaymentMethod" class="banner">
      <button type="button" class="back-button" (click)="reroute()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <!-- Mobile automatic payment layout -->
        <div class="mobile-layout" *ngIf="isPhone && !formLayout && !error">
          <div class="page-icon">
            <app-zaver-icon [size]="92" name="swishLogoAlt"></app-zaver-icon>
          </div>
          <div class="loading-info-container">
            <div class="spinner-container">
              <app-spinner [overrideMargins]="true"> </app-spinner>
            </div>
            <div class="status-message">
              {{ mobileStatusMessage }}
            </div>
          </div>

          <ng-container *ngIf="manualDeeplinkEnabled">
            <div class="alert-container">
              <div class="deeplink-button" (click)="startSwish()">
                Öppna Swish
              </div>
            </div>

            <div class="open-on-other-device" (click)="restartOnOtherDevice()">
              Swisha från en annan enhet
            </div>
          </ng-container>
        </div>

        <!-- Form layout, desktop or other device requested on mobile -->
        <ng-container *ngIf="formLayout && !error && !paymentStatusOtherDevice">
          <div class="page-icon">
            <app-zaver-icon [size]="86" name="phoneCircle"></app-zaver-icon>
          </div>

          <div class="page-text">
            Ange det mobilnummer du vill göra betalningen ifrån.
          </div>

          <form [formGroup]="form">
            <div class="input-container">
              <zaver-animated-form-input
                [formControlName]="'phone'"
                [ariaLabel]="'Ange mobilnummer'"
                [error]="form.controls.phone.invalid && showError"
                [inputMode]="'tel'"
                [placeholder]="'Mobilnummer'"
                [errorMessage]="
                  'Vänligen ange ett giltigt mobilnummer (07******** eller +***********)'
                "
                [size]="'large'"
                [errorIcon]="'assets/icon/icon_error.svg'"
                (onKeyboardEnter)="initPayment()"
              ></zaver-animated-form-input>
            </div>
          </form>

          <div *ngIf="amount" class="pr-info">
            <label> Totalbelopp </label>
            <label>
              {{
                amount.toLocaleString('sv', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }}
              SEK
            </label>
          </div>

          <!-- Need to update component to support new icons-->
          <zaver-primary-button
            [text]="'Swisha'"
            [logo]="'/assets/icon/Swish_Logo_Primary.svg'"
            (click)="initPayment()"
          ></zaver-primary-button>
        </ng-container>

        <!-- While payment active on other device -->
        <ng-container *ngIf="!!error || !!paymentStatusOtherDevice">
          <div class="active-payment-wrapper">
            <div class="alert-container" *ngIf="!!error">
              <zaver-alert-box
                [messageList]="getErrorMessages()"
                type="WARNING"
              >
              </zaver-alert-box>
            </div>
            <div
              class="alert-container"
              *ngIf="!!paymentStatusOtherDevice && !error"
            >
              <zaver-alert-box [text]="paymentStatusOtherDevice" type="INFO">
              </zaver-alert-box>
            </div>
            <div
              class="cancel-transaction"
              *ngIf="!!paymentStatusOtherDevice"
              (click)="restartOnOtherDevice()"
            >
              Avbryt överföring
            </div>

            <div class="pr-info" *ngIf="amount && (!isPhone || !!error)">
              <label> Totalbelopp </label>
              <label>
                {{
                  amount.toLocaleString('sv', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })
                }}
                SEK
              </label>
            </div>

            <zaver-primary-button
              *ngIf="isPhone && !!error"
              [text]="'Försök igen'"
              [loading]="paymentInProgress || isPolling()"
              [disabled]="paymentInProgress || isPolling()"
              [logo]="'/assets/icon/Swish_Logo_Primary.svg'"
              (click)="restartMobilePayment()"
            ></zaver-primary-button>

            <zaver-primary-button
              *ngIf="!isPhone"
              text="Försök igen"
              [loading]="!error"
              [disabled]="!error"
              logo="/assets/icon/Swish_Logo_Primary.svg"
              (click)="restartFormBasedPayment()"
            ></zaver-primary-button>
          </div>
        </ng-container>

        <app-se-terms
          *ngIf="!!paymentRequest.specificPaymentMethod"
          [paymentRequest]="paymentRequest"
        ></app-se-terms>
      </div>
    </div>
  </div>
</div>
